import {
	getAddableTreeItemSubConfiguratorComponentsForBulkSelection,
	TransformedSubConfiguratorOrListComponent,
} from "./treeItemModel/configuratorTreeItemQueries";
import { AddSubConfiguratorsToTreeViewProps } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/AddSubConfiguratorsToTreeView.tsx";
import { SubConfigurationBulkSelectionView } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/SubConfigurationBulkSelectionView.tsx";

export const AddSubConfiguratorsToTreeViewBulk = ({
	treeItem,
	closeDialog,
	onSubmit,
}: AddSubConfiguratorsToTreeViewProps) => {
	return (
		<SubConfigurationBulkSelectionView<TransformedSubConfiguratorOrListComponent>
			getAvailableItems={(selected) =>
				getAddableTreeItemSubConfiguratorComponentsForBulkSelection(treeItem, selected)
			}
			getItemKey={(component) => component.configurationComponentId}
			getItemLabel={(component) => component.label}
			closeDialog={closeDialog}
			onSubmit={onSubmit}
		/>
	);
};
